export enum MeasureUnitEnum {
    Milligrams = 1,
    Grams = 2,
    Kilograms = 3,
    Milliliters = 4,
    Liters = 5,
    Pint = 6,
    Each = 7,
    Pack = 8,
    Carton = 9,
    Bottle = 10,
    Can = 11,
    Kiloliters = 12,
    Gallon = 13
}
